import React,{useState, useEffect} from "react";
import {
  House,
  Plus,
  ClipboardList,
  ListChecks,
  Gift,
  Settings,
  X,
  Wallet,
  ChevronDown,
  User,
  ShieldCheck,
  Bell,
  LifeBuoy,
} from "lucide-react";

// import userone from "../../assets/img/user1.jpg";
import { NavLink, useLocation } from "react-router-dom";
import ProfileSideBar from "./ProfileSideBar";
import SurveyFilters from "./SurveyFilters";

const DashboardLeftSidebar = ({ activeTab, sidebarOpen, onClose }) => {

  const location = useLocation();
  const isSearchResultsPage = location.pathname === "/search-results";
  const isSettingsPage = location.pathname.startsWith("/settings");
  const isSurveyResultsPage = location.pathname.startsWith("/survey-results/");

  const [settingsOpen, setSettingsOpen] = useState(isSettingsPage);

  useEffect(() => {
    if (isSettingsPage) setSettingsOpen(true);
  }, [isSettingsPage]);

  const settingsSubLinks = [
    { to: "/settings/profile", label: "Profile", icon: User },
    { to: "/settings/account-security", label: "Account & Security", icon: ShieldCheck },
    { to: "/settings/notifications", label: "Notifications", icon: Bell },
    { to: "/settings/support", label: "Support", icon: LifeBuoy },
  ];


  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  useEffect(() => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("user")
    ) {
      setIsLoggedIn(true);
    }
  }, []);


  // const [isLoggedIn, setIsLoggedIn] = useState(() =>
  //   Boolean(
  //     localStorage.getItem("token") &&
  //     localStorage.getItem("user")
  //   )
  // );


  const industryOptions = [
    { value: "technology", label: "Technology & SaaS" },
    { value: "healthcare", label: "Healthcare" },
    { value: "finance", label: "Finance" },
    { value: "education", label: "Education" },
  ];

  const locationOptions = [
    { value: "delhi", label: "Delhi" },
    { value: "noida", label: "Noida" },
    { value: "gurgaon", label: "Gurgaon" },
    { value: "mumbai", label: "Mumbai" },
  ];



  return (
    <div
      className={`col-xl-3 col-md-4 col-12 leftsidebar ${
        sidebarOpen ? "sidebar-open" : ""
      }`}
      style={sidebarOpen ? { display: "block" } : undefined}
    >
      <div className="d-flex align-items-center justify-content-between mb-4 d-xl-none dashboard-sidebar-close">
        <h4 className="fw-bold mb-0">Dashboard Menu</h4>
        <button
          type="button"
          className="btn btn-dark rounded-circle p-2"
          onClick={onClose}
          aria-label="Close dashboard menu"
        >
          <X size={18} />
        </button>
      </div>



      {!isSearchResultsPage && isLoggedIn && (
        <>
            <ProfileSideBar/>
            <div className="menucard mb-4">
              {/* Hide this entry while preserving the feed route. */}
              <NavLink to="/feed" className={`menu-link ${isSurveyResultsPage ? "" : "d-none"}`}>
                <House size={22} />
                Dashboard
              </NavLink>

              <NavLink to="/create-survey" className="menu-link">
                <Plus size={22} />
                Create Survey
              </NavLink>

              <NavLink to="/my-surveys" className="menu-link">
                <ClipboardList size={22} />
                My Surveys
              </NavLink>

              <NavLink to="/survey-for-me" className="menu-link">
                <ListChecks size={22} />
                Surveys For Me
              </NavLink>

              <NavLink to="/my-wallet" className="menu-link">
                <Wallet size={22} />
                My Wallet
              </NavLink>

              <button
                type="button"
                className={`menu-link w-100 border-0 bg-transparent d-flex align-items-center ${
                  isSettingsPage ? "active" : ""
                }`}
                onClick={() => setSettingsOpen((open) => !open)}
                aria-expanded={settingsOpen}
              >
                <Settings size={22} />
                Settings
                <ChevronDown
                  size={16}
                  className="ms-auto"
                  style={{
                    transform: settingsOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
              </button>

              {settingsOpen && (
                <div className="menu-submenu ps-4">
                  {settingsSubLinks.map((item) => (
                    <NavLink key={item.to} to={item.to} className="menu-link menu-sublink">
                      <item.icon size={18} />
                      {item.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          </>
      )}

       {isSearchResultsPage && (
          <SurveyFilters activeTab={activeTab} />
        )}



    </div>
  );
};

export default DashboardLeftSidebar;
